import { css } from 'styled-components'
import { authDivider } from '../../pages/auth-card'

// The sign in form's own look (fields, links, actions), shared by the sign in page and the guest
// prompt so the same markup looks the same wherever it is hosted.
export const signInForm = css`
  ${ authDivider }

  .fields {
    display: flex;
    flex-direction: column;
  }

  .link {
    text-align: center;

    span {
      color: ${ ({ theme }) => theme.colors.primary };
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 15px;
      text-align: center;
      cursor: pointer;
    }

    :hover {
      text-decoration: underline;
    }
  }

  .forgotten-password {
    text-align: right;
    margin-top: -25px;

    span {
      font-size: 14px;
      font-weight: 400;
    }
  }

  .actions {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;

    button {
      height: 52px;
      font-size: 16px;
      letter-spacing: 1px;

    }

    .divider {
      margin: 28px 0 20px;
    }

    .secondary-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;

      span {
        /* Both links share the row evenly, whatever the length of their labels. */
        flex: 1 1 0;
        min-width: 0;
        color: ${ ({ theme }) => theme.colors.primary };
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 0.5px;
        text-align: center;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    /* "Got a verification code? Enter it here", right under the button as in the mock. */
    .verification {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      gap: 4px;
      margin-top: 16px;
      /* Figma: Assistant 500 12/16, Neutral/Grey06; the link is the same in ExtraBold. */
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: 0;
      color: ${ ({ theme }) => theme.colors.black };

      .go {
        font-weight: 800;
        cursor: pointer;
      }
    }
  }

  /* While signing in / sending: the spinner takes the button's place, centred and just as tall. */
  .actions .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
  }

  .error-container {
    flex-direction: row;
    justify-content: center;
    margin-top: 25px;
    width: 100%;
    text-align: center;
    align-self: center;

    .error {
      color: ${ ({ theme }) => theme.colors.red };
      text-align: center;
    }
  }
`
